import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import HomePage from "../components/display";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { ASSISTANT_URL } from '../constants';
import { ChatContext } from '../context/ChatContext';
import { AuthContext } from '../context/AuthContext';
import Chat from "./chat";

const Dashboard = () => {
  // Contexto de autenticación: contiene nom, curso y funciones para actualizar usuario y curso
  const { nom, curso, setUser, setCourse } = useContext(AuthContext);

  // Contexto del chat: controla si se muestra el chat, el historial, etc.
  const {
    chatShow,
    setChatShow,
    setChatMessage,
    setShowChatTime,
    showChatTime
  } = useContext(ChatContext);

  // Estado para controlar el sidebar
  const [isOpen, setIsOpen] = useState(false);

  // Función para obtener detalles del usuario usando el parámetro `nom`
  const fetchUserDetails = async () => {
    try {
      const response = await axios.post(`${ASSISTANT_URL}/api/auth/nom`, { nom });
      setUser(response.data);
    } catch (error) {
      console.error("fetchUserDetails: Error al obtener datos del usuario:", error);
    }
  };

  // Función para obtener detalles del curso usando el parámetro `curso`
  const fetchCourseDetails = async () => {
    try {
      const response = await axios.post(`${ASSISTANT_URL}/api/auth/curso`, { curso });
      setCourse(response.data);
    } catch (error) {
      console.error("fetchCourseDetails: Error al obtener datos del curso:", error);
    }
  };

  // Inicializa un nuevo diálogo de chat (historial vacío, nuevo timestamp)
  const handleNewDialogClick = () => {
    setChatShow(true);
    setChatMessage([]);
    setShowChatTime(new Date().toISOString());
  };


  // Efecto único al montar el componente: si ya hay `nom` y `curso` (por login o localStorage), inicializa todo
  useEffect(() => {
  // Este efecto corre solo una vez al montar
  if (!nom || !curso) return;

  // Lógica de inicialización
  fetchUserDetails();
  fetchCourseDetails();
  handleNewDialogClick();
  }, []); // <= sin dependencias d URL

//-------------------------



  return (
    <div className="font-Inter flex items-start relative min-h-screen">
      {/* Sidebar lateral */}
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      {/* Contenedor principal con Header y contenido dinámico */}
      <div className={`flex flex-col transition-all duration-300 w-full h-screen bg-white-200 ${isOpen ? "lg:ml-0" : "lg:-ml-80"}`}>
        <Header />

        {/* Vista condicional: HomePage o Chat según estado del contexto */}
        {!chatShow ? (
          <HomePage onNewDialogClick={handleNewDialogClick} />
        ) : (
          <Chat time={showChatTime} />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
